import $ from 'jquery'; // Need jQuery because Slick Carousel depends on it.
import isElement from 'lodash/isElement';
import 'slick-carousel';

const config = {
	arrows: true,
	dots: true,
	infinite: false
}

export default class Carousel {

	constructor(el, options) {
		if (!isElement(el)) {
			return false;
        }

		this._config(el, options);
		this._setup();
	}

	_config(el, options) {
		this.el = el;
		this.options = options;

		this.carousel = $(this.el).find('.c-carousel__container');
	}

	_setup() {
		this.config = {
			...config,
			...this.options
		}

		$(this.carousel).slick(this.config);
    }
}